module.exports = __webpack_public_path__ + "static/media/munch10.10fef1dd.wav";